import {Component, OnInit} from '@angular/core';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {TableService, UserService, VisitedService} from '@amlCore/services';
import {ActivatedRoute, Router} from '@angular/router';
import {Utils} from '@amlCore/utils';
import {InternalService} from './internal.service';
import {InternalModel} from '../../model';
import {ClientTypeEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {forkJoin, Observable} from 'rxjs';
import {AccessJson} from '@amlCore/models';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ConfirmComponent} from "@amlCore/modals";

@Component({
  selector: 'app-internal-list',
  templateUrl: './internalList.component.html'
})
export class InternalListComponent extends TableReactiveUrlController implements OnInit {
  params: any;
  isShowVisited = true;
  internalList: InternalModel[] = [];
  clientTypeMap = new Map([
    [ClientTypeEnum.LEGAL_ENTITY, 'ЮЛ'],
    [ClientTypeEnum.INDIVIDUAL_PERSON, 'ФЛ'],
    [ClientTypeEnum.INDIVIDUAL_ENTREPRENEUR, 'ИП'],
    [ClientTypeEnum.PRIVATE_PRACTITIONER, 'ФЛ ЧП'],
    [ClientTypeEnum.FOREIGN_STRUCTURE, 'ИНБОЮЛ']
  ]);
  access: AccessJson;

  constructor(protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router,
              protected readonly internalService: InternalService,
              private readonly usersService: UserService,
              private readonly modalService: NgbModal) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'orgNameRu', dir: 'ASC'});
  }

  ngOnInit(): void {
    this.access = this.usersService.getAccess(RegistriesAccessEnum.QREF_INTERNALORG);
    this.activatedRoute.queryParams.subscribe((data) => {
      this.loadList(this.syncParams(data));
    });
  }

  loadList(params?: any): void {
    // Удаляем системные переменные
    Utils.removeKeysFromObj(params, '$refresh');
    this.internalService.getList(this.getParams(params)).subscribe(data => {
      this.internalList = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  onPageChange(params): void {
    this.navigate({...params, ...this.getParams(this.filter)});
    this.resetSelectedAll();
  }

  onSearch(): void {
    const params = this.getSearchPage(this.filter);
    this.onPageChange(params);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data): any {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  open(data: InternalModel): void {
    if(this.access.readOnly){
      this.toggleView(data.id);
    } else {
      this.tableService.saveScrollPosition(this.commonKeyStore);
      this.router.navigate([`/registries/${this.access.readOnly?"internalView":"internal"}/${data.id}`]);
      this.saveRowId(data.id);
    }

  }

  /**
   * Метод вызываемый после импорта
   */
  importLoad(result): void {
    const list = result.data;
    let comp = result.comp;
    let event = result.event;

    if(list === 409){
      const modal = this.modalService.open(ConfirmComponent);
      modal.componentInstance.title = "Внимание";
      modal.componentInstance.text = "Субъект уже зарегистрирован в базе. Данные будут перезаписаны";
      modal.componentInstance.okBtn = "Ок";
      modal.componentInstance.cancelBtn = "Отмена";
      modal.componentInstance.hideCloseBtn = true;
      modal.result.then(() => {
        comp.queryParams = comp.queryParams.set("forceUpdate","true");
        comp.sendFiles(event.target.files, event, false);
      }, () => {
        comp.reset();
      });
    }else{
        comp.reset();
        // Подмешиваем случайную переменную для реализации обновления при импорте
        this.onPageChange({$refresh: Math.random()});
    }
  }

  /**
   * Удаление выбранных записей
   */
  deleteSelected(): void {
    const deleteReq = [];
    const deleteItem = [];
    this.getSelectedModel(this.internalList).forEach((item: InternalModel) => {
      deleteReq.push(this.deleteInternal(item.id));
      deleteItem.push(item);
    });
    forkJoin(deleteReq).subscribe(() => {
      deleteItem.forEach(item => this.selectRow(item));
      this.onPageChange({$refresh: Math.random()});
    });
  }

  /**
   * Удаление записи
   * @param id - id записи
   */
  deleteInternal(id: string): Observable<any> {
    return this.internalService.deleteInternal(id);
  }

  /**
   * Столбец "Наименование/ФИО"
   * @param item - строка
   */
  getName(item: InternalModel): string {
    return this.internalService.getName(item);
  }
}
